module.exports = __webpack_public_path__ + "img/trainingRegister.48248d86.png";